import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Admin } from 'src/app/interfaces/admin';
import { Router } from '@angular/router';
import { AdminAccessService } from 'src/app/services/admin-access.service';
import { AuthService } from 'src/app/services/auth.service';

@Component({
  selector: 'app-orders-login',
  templateUrl: './orders-login.component.html',
  styleUrls: ['./orders-login.component.scss']
})
export class OrdersLoginComponent implements OnInit {

  constructor(private router: Router, private sendAccess: AdminAccessService, private auth:AuthService) { }

  generalAdminEmail:string ='controlpanel2020@admin.com'

  generalAdminPassword: string = 'controlpanel2020admin'

  al3aliaEmail:string ='al3aliaControlPanal2020@admin.com'

  al3aliaPassword: string = 'al3aliaControlPanal2020'

  yaqotEmail:string ='yaqotControlPanal2020@admin.com'

  yaqotPassword: string = 'yaqotControlPanal2020'

  basatenEmail:string ='basatenControlPanal2020@admin.com'

  basatenPassword: string = 'basatenControlPanal2020'

  access: boolean =true;

  loading: boolean = false

  errorMessage: string = ''

  submit:boolean = true

  ngOnInit() {}

  login(f:NgForm) {

    this.submit = false

    this.loading = true

    let email = (<Admin>f.value).email,
        password = (<Admin>f.value).password;
          // this.sendAccess.sendAccess(this.access)         
          this.auth.login(email,password).then(()=>{
              this.router.navigate(['/switcher'])
          })
          .catch(error =>{
            this.loading = false
            this.submit = true
            this.errorMessage = error.message
          })
  }
}
